import { useHookstate } from "@hookstate/core";
import { useEffect } from "react";
import { rootComponentsStore } from "../hookstate/rootComponentsStore";

export function useTitleOnNavigation(title?: string | null) {
  const isInitialLoad = useHookstate(rootComponentsStore.isInitialLoad).get({
    noproxy: true,
  });

  useEffect(() => {
    if (isInitialLoad) {
      rootComponentsStore.isInitialLoad.set(false);
    } else {
      if (title) {
        document.title = title;
      }
    }
  }, [title]);
}
